import { WifiOff } from 'lucide-react';
import { AnimatePresence, motion } from 'motion/react';
import { useEffect, useState } from 'react';

import { useSession } from '@/shared/auth';
import { springs } from '@/shared/lib/motion';
import { useConnectionState } from '@/shared/realtime';
import { t } from '@/shared/i18n';

import styles from './ConnectionBar.module.scss';

/**
 * Тонкая полоска «нет связи» под шапкой. Показывается не сразу: при входе
 * и при обычном переподключении соединение восстанавливается за секунду,
 * и мигать полоской незачем.
 */
export function ConnectionBar() {
  const state = useConnectionState();
  const session = useSession();
  // «Давно офлайн» — отдельное состояние, которое взводится таймером;
  // само «офлайн сейчас» считается при рендере.
  const [longOffline, setLongOffline] = useState(false);
  const offline = state !== 'online' && session.status === 'authenticated';

  useEffect(() => {
    if (!offline) {
      return;
    }

    const timer = setTimeout(() => {
      setLongOffline(true);
    }, 2500);

    return () => {
      clearTimeout(timer);
      setLongOffline(false);
    };
  }, [offline]);

  const visible = offline && longOffline;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          key="offline"
          className={styles['bar']}
          role="status"
          initial={{ y: -32, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -32, opacity: 0 }}
          transition={springs.rubber}
        >
          <WifiOff />
          {t.presence.offline}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
